export default {
  NO_ASINID: '无商品ID！',
  LOGIN_INFORMATION_IS_INCORRECT_PLEASE_LOG_IN_AGAIN:
    '登录信息错误，请重新登录！',
  API_ERRPR: '接口错误！',
  YUAN_EXCLUSIVE_FOR_NEW_CUSTOMER: '元 [新人专享]',
  COUPON_EXCLUSIVE_FOR_NEW_CUSTOMER: '优惠券 [新人专享]',
  FREE_SHIPPING: '+免运费',
  FREE_SHIPPING_EXCLUSIVE_FOR_NEW_CUSTOMER: '免运费 [新人专享]',
  NEW_CUSTOMER_COUPONS: '新人优惠券',
  PAY_NOW: '立即支付',
  NO_MORE: '没有更多了',
  REQUEST_FAILED_CLICK_TO_RELOAD: '请求失败，点击重新加载',
  PURCHASE: '购入',
  ALL_C_REVIEW: '全部评价',
  JUMP_TO_SEARCH_PAGE: '跳转搜索页',
  SEARCH: '搜索',
  COMPREHENSIVE_SORTING: '综合排序',
  PRICE: '价格',
  AMAZON_GLOBAL_BRAND_STORE: '亚马逊海外购品牌店',
  COUPONS: '优惠券',
  TERMS_AND_CONDITION: '使用规则',
  ALL_CATEGORY_BENEFITS_FOR_FULL_SELECTION: '全场全品类福利',
  AVAILABEL_PRODUCTS: '可用商品',
  CLAIMNOW: '立即领取',
  CURRENTLY_NO_COUPONS_AVAILABLE: '暂无优惠券',
  I_SEE: '我知道了',
  FULL: '满',
  BOT_AVAILABLE: '无可用',
  CLAIMED_SUCCESSFULLY: '领取成功',
  BEST_SELLING_ITEM_RECOMMENDATION: '畅销单品推荐',
  C_REVIEW: '买家评价',
  NO_C_REVIEW_CURRENTLY_AVAILABLE: '暂无买家评价',
  VIEW_ALL: '查看全部',
  AMAZON_PURCHASER: '亚马逊买家',
  ADD_YOUER_C_REVIEW: '添加您的评价',
  AFTER_THE_COUPON_DISCOUNT: '券后',
  SAVE: '节省',
  CLAIM_THE_COUPON: '领券',
  SEARCH_FOR_MORE_GLOBAL_STORE_PRODUCTS: '搜索更多海外购商品',
  PRODUCT: '商品',
  DETAIL: '详情',
  REVIEW: '评价',
  RECOMMEND: '推荐',
  OTHER_SELLERS_SELLING_THE_SAME_PRODUCT: '同款商品的其他卖家',
  SELECTED: '已选',
  SHIPPING: '发货',
  AMAZON: '亚马逊',
  SOLD_AND_SHIPPED: '销售发货',
  EXPRESS_DELIVERY: '快递',
  FREIGHT_IS_SUBJECT_TO_ACTUAL_SETTLEMENT: '实际运费以结算为准',
  SEND_TO: '送至',
  GLOBAL_STORE_DIRECT_SHIPPING_PACKAGES_USUALLY_TAKE_4_12_DAYS_TO_DELIVER:
    '海外购包裹通常需要4-12天送达',
  PLEASE_SELECT_THE_ADDRESS: '请添加收货地',
  CSF: '进口费用',
  ESTIMATE: '预计',
  IFD_IS_SUBJECT_TO_ACTUAL_SETTLEMENT: '实际税费以结算为准',
  NOT_SUPPORT_30_DAY_RETURN_WITHOUT_AREASON: '不支持30天无理由退货',
  AMAZON_GLOBAL_STORE: '亚马逊海外购',
  SALES_AND_SHIPPING: '销售发货',
  PRODUCT_DETAIL: '商品详情',
  PRODUCT_FEATURES_BASIC_INFORMATION: '商品特点 & 基本信息',
  AMAZON_GLOBAL_STORE_TIPS: '亚马逊海外购小贴士',
  GATEWAY: '首页',
  CART: '购物车',
  ALREADY: '已',
  COLLECT: '收藏',
  ADD_TO_CART: '加入购物车',
  PURCHASE_CLAIM_THE_COUPON: '领券购买',
  PURCHASE_IMMEDIATELY: '立即购买',
  COLLECT_SUCCESSFULLY: '收藏成功',
  COLLECT_FAILED: '收藏失败',
  THE_CURRENT_ASIN_IS_TEMPORARILY_OUT_OF_STOCK: '当前商品暂时无货',
  VIEW_OTHER_ASINS: '查看其他商品',
  JUMP_TO: '跳转',
  CONTINUE_SLIDING_TO_VIEW_C_REVIEWS: '继 续 滑 动 查 看 买 家 评 价',
  TOTAL: '共',
  SORT: '种',
  CURRENTLY_OUT_OF_STOCK: '目前无货',
  RELEASE_SLIDE_TO_VIEW_C_REVIEWS: '释 放 滑 动 查 看 买 家 评 价',
  DOTD_DISCOUNTED_PRICE: '镇店价',
  TIME_REMAINING: '距结束',
  DOTD: '镇店之宝',
  BEST_DEAL_PRICE: '特卖价',
  BEST_DEAL: '特卖汇',
  DAY: '天',
  PRODUCT_INFO: '产品信息',
  SEARCH_FOR_MILLIONS_OF_PRODUCTS: '搜索千万种商品',
  USUALLY_SHIPS_WITHIN_WEEKS: '通常需要4-6周发货',
  UP: '起',
  BUY_NOW_OR_MISS_OUT: '欲购从速',
  PLEASE_BROWSE_OTHER_PRODUCTS: '快去看看其他商品',
  ALL: '全部',
  AMAZON_BUYER: '亚马逊买家',
  GO_APP_VIEW: '前往APP查看',
  SIZE_CHART: '尺码表'
};
